export const RoleandRightsAction = (data) => {
    return {
      type: 'RoleandRightsAction',
      payload: data
    }
}
